import React from 'react'
import { Helmet } from 'react-helmet-async'

const SchemaMarkup = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "MindVista",
    "url": "https://mindvista.io",
    "logo": "https://mindvista.io/images/logo-white.png",
    "email": "business@mindvista.io",
    "address": [
      {
        "@type": "PostalAddress",
        "streetAddress": "89 C, Punjab Housing Society",
        "addressLocality": "Lahore",
        "addressCountry": "PK"
      },
      {
        "@type": "PostalAddress",
        "streetAddress": "1209 Mountain Road Pl NE Ste R",
        "addressLocality": "Albuquerque",
        "addressRegion": "NM",
        "postalCode": "87110",
        "addressCountry": "US"
      }
    ],
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "telephone": "+92-309-8391932",
        "contactType": "customer service",
        "email": "business@mindvista.io",
        "areaServed": "PK"
      },
      {
        "@type": "ContactPoint",
        "telephone": "+1-575-303-9239",
        "contactType": "customer service",
        "email": "business@mindvista.io",
        "areaServed": "US"
      }
    ],
    "sameAs": [
      // Add social links here if available
    ]
  }

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  )
}

export default SchemaMarkup
